// This file was auto-generated by Fern from our API Definition.
export const ToolProviderKind = {
    Composio: "composio",
    Agenta: "agenta",
};
